module.exports = __webpack_public_path__ + "img/slider_a02.b1d6913.887e9028.png";